import { Component, OnInit, OnDestroy, AfterViewInit, SimpleChanges, OnChanges, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { ClBaseComponent } from '../cl-base/cl-base.component';
import { Resource, ResourceRelation } from 'src/app/components/catalogs/beamline-catalog/resource/resources';
import { ResourceType } from 'src/app/common/enumerations/enumerations';

@Component({
  selector: 'cl-bratoi',
  templateUrl: './cl-bratoi.component.html',
  styleUrls: ['./cl-bratoi.component.scss']
})
export class ClBRATOIComponent extends ClBaseComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

  @Input() resourceID?: number | null;

  resource?: Resource;
  resources?: Resource[];
  resourcesSubs!: Subscription;

  ngOnInit() {
    this.loadResources();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.ngAfterViewInit();
  }

  override ngOnDestroy(): void {
    this.resourcesSubs?.unsubscribe();
    super.ngOnDestroy();
  }

  ngAfterViewInit() {
    this.initials = this.user ? this.user.initials : '';
  }

  /**
   * Loads catalog resources and resolves a shutter input to its related Beamline for display.
   */
  loadResources() {
    this.resourcesSubs = this.store.select(state => state.Resources.data).subscribe((data: Resource[]) => {
      if (data?.length) {
        this.resources = data;
        const selectedResource = data.find(r => r.id === this.resourceID);

        // Checklist resource IDs commonly identify the shutter, while BRATOI text must name the Beamline.
        if (selectedResource && (selectedResource.type ?? selectedResource.resourceTypeID) === ResourceType.Shutter) {
          const beamlineRelation = selectedResource.childResources?.find((relation: ResourceRelation) => relation.childResourceType === ResourceType.Beamline);
          this.resource = data.find(r => r.id === beamlineRelation?.childResourceID) ?? beamlineRelation?.childResource ?? selectedResource;
        } else {
          this.resource = selectedResource;
        }
      }
    });
  }

  checkboxChanged(e: any) {
    this.checked = e.checked;
    this.answered.emit(this.checked);
  }

  override get labelHtml(): string {
    const before = this.stripDiv(this.textBefore);
    const name = this.resource?.name ?? '[Resource Name]';
    const after = this.stripDiv(this.textAfter);
    return `${before} <b class="blue">${name}</b> ${after}`;
  }

}
